import { memo } from 'react';

import { QuantityInput } from 'src/components/products/quantity-input';

interface QuantityCellProps {
  params: any;
  handleQuantityChange: any;
}

export const QuantityCell = memo(({ params, handleQuantityChange }: QuantityCellProps) => (
  <QuantityInput
    productName={params.row.name}
    value={params.row.quantity}
    onChange={(value) =>
      handleQuantityChange(params.row.productStockId, value - params.row.quantity)
    }
    minimumValue={1}
    maximumValue={params.row.surplusEntries?.reservedQuantity}
  />
));
